import {useMemo} from 'react'
import {useQuery} from '@tanstack/react-query'
import {getPlans} from '@api/subscription.js'

export default function usePlans(country) {
  const detectedCountry = useMemo(
    () => country || (navigator.language || '').split('-').pop().toLowerCase(),
    [country]
  )

  const query = useQuery({
    queryKey: ['subscription-plans', detectedCountry],
    queryFn: () => getPlans(detectedCountry),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1
  })

  if (query.isLoading && !query.data) return null
  if (query.error && !query.data) return []

  const raw = query.data
  return Array.isArray(raw) ? raw : raw?.plans || []
}
